// extracted by mini-css-extract-plugin
module.exports = {"leadership-cards-list":"LeadershipList_leadership-cards-list__Cu3y3","leadership-owners-list":"LeadershipList_leadership-owners-list__lePQ5"};